import { render, staticRenderFns } from "./PermitAnswerHistoryModal.vue?vue&type=template&id=1ffbc2c9&"
import script from "./PermitAnswerHistoryModal.vue?vue&type=script&lang=js&"
export * from "./PermitAnswerHistoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports